import React from "react";
import { Link } from "react-router-dom";
import { Cookie as CookieIcon } from "lucide-react";

const Section = ({ n, title, children }) => (
    <section className="mt-8">
        <h2 className="text-2xl font-serif font-medium">{n}. {title}</h2>
        <div className="text-muted-foreground leading-relaxed mt-3 space-y-3">{children}</div>
    </section>
);

export default function Cookie() {
    const reopen = () => {
        localStorage.removeItem("incipit-cookie-consent");
        window.location.reload();
    };
    return (
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
            <div className="flex items-center gap-3 mb-3">
                <CookieIcon className="text-primary" size={30} />
                <h1 className="text-4xl sm:text-5xl font-serif font-medium">Cookie Policy</h1>
            </div>
            <p className="text-sm text-muted-foreground">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT")}</p>

            <p className="text-muted-foreground leading-relaxed mt-6">
                La presente Cookie Policy descrive cosa sono i cookie e come vengono utilizzati sulla piattaforma
                <strong> Incipit — Editoria Libera</strong>, in conformità alle Linee Guida del Garante per la protezione
                dei dati personali e alla normativa vigente (Direttiva ePrivacy e GDPR).
            </p>

            <Section n="1" title="Cosa sono i cookie">
                <p>
                    I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell’utente, dove
                    vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva. Possono avere
                    finalità tecniche, di preferenza o statistiche.
                </p>
            </Section>

            <Section n="2" title="Cookie utilizzati da questa Piattaforma">
                <p>Incipit utilizza esclusivamente cookie e tecnologie di archiviazione locale <strong>tecnici e necessari</strong>:</p>
                <ul className="list-disc pl-6 space-y-1.5">
                    <li><strong>Cookie di autenticazione</strong> (es. <code className="font-mono-metric text-sm">access_token</code>, <code className="font-mono-metric text-sm">session_token</code>): cookie <em>httpOnly</em> necessari a mantenere l’utente autenticato durante la sessione. Senza di essi non è possibile effettuare l’accesso.</li>
                    <li><strong>Preferenze locali</strong> (localStorage): memorizzano la scelta del tema chiaro/scuro (<code className="font-mono-metric text-sm">incipit-theme</code>) e il consenso ai cookie (<code className="font-mono-metric text-sm">incipit-cookie-consent</code>).</li>
                </ul>
                <p>Non utilizziamo cookie di profilazione pubblicitaria né cookie di tracciamento di terze parti a fini di marketing.</p>
            </Section>

            <Section n="3" title="Cookie di terze parti">
                <p>
                    In caso di accesso tramite Google, il provider di autenticazione può impostare propri cookie tecnici
                    necessari alla procedura di login. Ti invitiamo a consultare l’informativa privacy di Google per i dettagli.
                </p>
            </Section>

            <Section n="4" title="Base giuridica e consenso">
                <p>
                    I cookie tecnici non richiedono il consenso in quanto strettamente necessari al funzionamento del
                    Servizio. Per eventuali cookie non essenziali viene richiesto il consenso preventivo tramite l’apposito banner.
                    Puoi modificare le tue scelte in qualsiasi momento.
                </p>
            </Section>

            <Section n="5" title="Come gestire i cookie">
                <p>
                    Puoi gestire o disabilitare i cookie dalle impostazioni del tuo browser. La disabilitazione dei cookie
                    tecnici può però compromettere l’accesso e alcune funzionalità del sito. Puoi inoltre rivedere la tua
                    scelta sul consenso riaprendo il banner:
                </p>
                <button onClick={reopen} data-testid="reopen-cookie-banner" className="text-primary underline">Rivedi le preferenze sui cookie</button>
            </Section>

            <Section n="6" title="Aggiornamenti">
                <p>La presente Cookie Policy può essere aggiornata. Consulta periodicamente questa pagina. Per ulteriori dettagli sul trattamento dei dati vedi la <Link to="/privacy" className="text-primary underline">Informativa Privacy</Link>.</p>
            </Section>

            <p className="text-xs text-muted-foreground mt-10 border-t border-border pt-6">
                Nota: il presente testo è un modello informativo di base fornito a scopo illustrativo. Ti consigliamo di
                farlo verificare da un professionista prima dell’uso in produzione.
            </p>
        </div>
    );
}
